import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.user-labels', {
        url: '/user-label/:userLabelId',
        params: {userLabelId: null},
        component: 'companyUserLabels',
        resolve: {
			$breadcrumbs,
			companyUsers,
			labelGroup,
			userLabelId
        },
    });
}

/** @ngInject */
function $breadcrumbs(labelGroup) {
    const displayName = labelGroup.labelName;
    return [
        {stateName: 'company.user-directories.saaspass-users.user-labels'},
        {title: displayName ? `TEAM: ${displayName}` : `TEAM MANAGMENT`},
    ];
}

/** @ngInject */
function companyUsers(userLabelId,UserLabelsService,companyId){
	//var labelId=userLabel.id;
	//var userLabelId=$stateParams.userLabelId;
	return UserLabelsService.getCompanyUsers({'companyId':companyId,'labelId':userLabelId}).$promise;
}

/** @ngInject */
function labelGroup(userLabelId,UserLabelsService,companyId){
	//var labelId=userLabel.id;
	//var userLabelId=$stateParams.userLabelId;
	return UserLabelsService.getLabel({'companyId':companyId,'labelId':userLabelId}).$promise;
}

/** @ngInject */
function userLabelId($stateParams) {
    return  $stateParams.userLabelId;
}


// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/user-labels.state.js